import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-attachment-02',
  imports: [],
  templateUrl: './attachment-02.html',
  styleUrl: './attachment-02.scss',
})
export class Attachment02 {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}